export default {
  form: {
    bank_account_number: {
      label: 'Rekeningnummer',
      placeholder: 'DE01101234567891234567',
    },
    bank_routing_number: {
      label: 'Routeringsnummer',
      placeholder: '110000000',
    },
    bank_country: {
      label: 'Land',
      placeholder: 'Duitsland',
    },
    bank_statement_descriptor: {
      label: 'Afschriftomschrijving',
      placeholder: 'Restaurantnaam',
      tooltip: 'Deze naam wordt weergegeven op bankafschriften van klanten',
    },
  },
  buttons: {
    next: 'Volgende',
    back: 'Terug',
    use_test_data: 'Testgegevens gebruiken',
  },
  test_data_hint: 'Testbankrekening geaccepteerd door {{gateways}}',
  read_only_warning:
    'Bankgegevens kunnen alleen worden gewijzigd door ons team. Neem contact op met support als u dit wilt aanpassen.',
};
